import styled from "styled-components";
import { Button } from "@onelogin/react-components";

const LargeButton = styled(Button)`
  width: 100%;

  &:disabled {
    cursor: not-allowed;
  }
`;

export default LargeButton;
